import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import AdminGateway from '~apis/admin';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TEditRoleDetailsReduxParams } from '~types/feat/admin';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { RoleStatusEnum } from '~utils/enums';

export default function* watchDeleteRole(api: AdminGateway): SagaWatcherReturnType {
    yield takeEvery('admin/adminDeleteRoleAttempt', handleDeleteRole, api);
}

function* handleDeleteRole(api: AdminGateway, data: PayloadAction<TEditRoleDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { status: _status, ...restOfDataPayload } = data.payload;

    const response = yield* call([api, api.editRoleDetails], {
        authToken,
        ...restOfDataPayload,
        status: RoleStatusEnum.Deactivated,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.adminDeleteRoleFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const roleListing = reduxState.admin.roleListing.data;

        const massagedRoleListing = roleListing.map(item => {
            if (item.roleId === data.payload.roleId) {
                return {
                    ...item,
                    status: RoleStatusEnum.Deactivated,
                    updatedAt: dayjs().toISOString(),
                };
            }

            return item;
        });

        yield put(combinedActions.adminSetRoleListingData(massagedRoleListing));
        yield put(combinedActions.adminDeleteRoleSuccess());
        yield put(combinedActions.adminSetDeleteRoleModalIsOpen(false));

        toast.success(SuccessMessages.AdminDeleteRoleSuccess);
    }
}
